module.exports = __webpack_public_path__ + "static/kvailifika-mobile-ac39f26c0c4c65876a6375fd185aabd4.svg";